<div class="col-12 pet-title-wrap" style="margin-top: 30px;">
  <h4 class="pet-section-title">{{ "shoppingbybrand" | transloco }}</h4>
</div>

<div class="scroll-menu brands-menu">
  <ng-container *ngFor="let el of allBrands; let i = index">
    <div class="scroll-item brand-card" (click)="bybrand(el)">

      <div class="brand-visual">
        <div class="brand-circle"></div>

        <div class="brand-img-wrap">
          <img [src]="fixImage(el.brand_logo)" alt="brand logo">
        </div>
      </div>

      <p class="brand-card-name">
        @if(isAr){
        {{ el.brandname_ar }}
        }
        @else{
        {{ el.brandname_en }}
        }
      </p>

    </div>
  </ng-container>
</div>